import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { RedirectCommand, Router } from '@angular/router';
import type { Observable } from 'rxjs';
import { first, map } from 'rxjs';

export function createPermissionGuard(getPermission: () => Observable<boolean>): CanActivateFn {
  return () => {
    const router = inject(Router);
    return getPermission().pipe(
      first(),
      map((hasPermission) => hasPermission || new RedirectCommand(router.parseUrl('/'))),
    );
  };
}
